module.exports = __webpack_public_path__ + "img/qjxm.3377ad5c.png";